import pre from './pre';
import cart from './cart.vue';
import config from './config';
import success from './success.vue';
import addon from './addon.vue'

export default {
  pre,
  components: {
    config,
    cart,
    addon,
    success,
  },
};
